import Vue from 'vue'

const state = {
  items: {}
}

const mutations = {
  SET_ITEMS (state, items) {
    state.items = items
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return Vue.prototype.$axios.get('delivery-items')
      .then(response => {
        commit('SET_ITEMS', response.data)
      })
  }
}

const getters = {
  getDeliveryItems: state => deliveryID => {
    return Object.values(state.items).filter(item => {
      return item.delivery_id === deliveryID
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
